"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); //TODO: Really we shouldn't be doing any of these specificities in the app - pretty hacky that we have to hard-code this stuff. So is only a temporary measure for now

var AVATAR_BUILDING_CHALLENGE = exports.AVATAR_BUILDING_CHALLENGE = "Avatar Building";
var CHARACTER_BUILDING_CHALLENGE = exports.CHARACTER_BUILDING_CHALLENGE = "Character Building";
var CHARACTER_BUILDING_CHALLENGE_URL = exports.CHARACTER_BUILDING_CHALLENGE_URL = "Character Building";
var CHARACTER_BUILDING_TASK = exports.CHARACTER_BUILDING_TASK = "character-building.0";